import { Suspense } from 'react'
import { Switch } from 'react-router-dom'

import RequireSignIn from '@main/components/RequireSignIn'
import { Loader } from '@h2/components/loading/loader'
import { Layout } from '@h2/common/components/layout'
import { Header } from '@h2/common/components/header'
import { Feedback } from '@h2/common/components/feedback'
import { RouteWithSubRoutes } from '@h2/common/components/routeWithSubRoutes'
import { routes as commonRoutes } from '@h2/common/routes'
import { routes as dashboardRoutes } from '@h2/features/dashboard/routes'
import { routes as skillsDecoderRoutes } from '@h2/features/skillsDecoder/routes'
import { routes as personalProfileRoutes } from '@h2/features/personalProfile/routes'
import { routes as careerHubRoutes } from '@h2/features/careerHub/routes'
import { routes as managementRoutes } from '@h2/features/management/routes'
import { routes as messagingRoutes } from '@h2/features/messaging/routes'
import { routes as planningRoutes } from '@h2/features/planning/routes'
import { routes as opportunitiesRoutes } from '@h2/features/opportunities/routes'
import { routes as programRoutes } from '@h2/features/programs/routes'
import { routes as occupationRoutes } from '@h2/features/occupations/routes'
import { routes as collegeRoutes } from '@h2/features/colleges/routes'
import { routes as majorRoutes } from '@h2/features/majors/routes'
import { routes as clusterRoutes } from '@h2/features/clusters/routes'
import { routes as earlyRoutes } from '@h2/features/upTheLadder/routes'
import { routes as assessmentListingRoutes } from '@h2/features/researchActivities/routes'
import { routes as budgetRoutes } from '@h2/features/budget/routes'
import { routes as privacyRoutes } from '@h2/features/privacyPolicy/routes'
import { routes as touRoutes } from '@h2/features/termsOfUse/routes'
import { routes as reportingRoutes } from '@h2/features/reporting/routes'

const renderRoute = ({ path, authenticated, ...rest }) => {
  if (authenticated) {
    return (
      <RouteWithSubRoutes
        key={path}
        path={path}
        {...rest}
        render={props => {
          return <RequireSignIn name={rest.name}>{rest.render(props)}</RequireSignIn>
        }}
      />
    )
  }

  return <RouteWithSubRoutes key={path} path={path} {...rest} />
}
const Router = () => {
  return (
    <Layout>
      <Header isSpaChild={true} />
      <Feedback />
      <Suspense fallback={<Loader />}>
        <Switch>
          {commonRoutes.map(renderRoute)}
          {dashboardRoutes.map(renderRoute)}
          {skillsDecoderRoutes.map(renderRoute)}
          {personalProfileRoutes.map(renderRoute)}
          {managementRoutes.map(renderRoute)}
          {messagingRoutes.map(renderRoute)}
          {planningRoutes.map(renderRoute)}
          {careerHubRoutes.map(renderRoute)}
          {opportunitiesRoutes.map(renderRoute)}
          {programRoutes.map(renderRoute)}
          {occupationRoutes.map(renderRoute)}
          {clusterRoutes.map(renderRoute)}
          {collegeRoutes.map(renderRoute)}
          {majorRoutes.map(renderRoute)}
          {earlyRoutes.map(renderRoute)}
          {assessmentListingRoutes.map(renderRoute)}
          {budgetRoutes.map(renderRoute)}
          {reportingRoutes.map(renderRoute)}
          {privacyRoutes.map(renderRoute)}
          {touRoutes.map(renderRoute)}
        </Switch>
      </Suspense>
    </Layout>
  )
}

export { Router }
